/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
const CurrencyColumnFormatter = (cellContent, row, rowIndex) => {
  const { currency = "-" } = row || {};
  return <>{!currency || currency === null ? "-" : currency}</>;
};

export default CurrencyColumnFormatter;
